import { render } from "./ExemptionNaturePageList.vue?vue&type=template&id=20a13010&scoped=true&ts=true"
import script from "./ExemptionNaturePageList.vue?vue&type=script&lang=ts"
export * from "./ExemptionNaturePageList.vue?vue&type=script&lang=ts"

import "./ExemptionNaturePageList.vue?vue&type=style&index=0&id=20a13010&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a13010"]])

export default __exports__